import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import * as XLSX from "xlsx";



class ModalImportar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            archivo: null,
            datosPrevisualizacion: [],
            paso: 1,
            isDragging: false,
            errorArchivo: null
        };
        this.fileInputRef = React.createRef();
    }

    // --- 1. DESCARGAR PLANTILLA (Formato CSV nativo) ---
    descargarPlantilla = () => {

    const encabezados = [
        [
            "Código de barras",
            "Nombre",
            "Marca",
            "Descripción",
            "Precio",
            "Precio 2",
            "Precio 3",
            "Precio 4",
            "Precio 5",
            "Familia",
            "Existencias",
            "Costo compra"
        ]
    ];

    const filaEjemplo = [
        [
            "7401001001",
            "Martillo 16oz",
            "Truper",
            "Mango de fibra",
            85.00,
            80.00,
            75.00,
            70.00,
            65.00,
            "Ferretería",
            10,
            50
        ]
    ];

    const data = [...encabezados, ...filaEjemplo];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);

    XLSX.utils.book_append_sheet(wb, ws, "Plantilla");

    XLSX.writeFile(wb, "plantilla_productos.xlsx");
};

    procesarArchivoXLSX = (file) => {
        if (!file) return;

        this.setState({ errorArchivo: null });


        // validar extension
        if (!file.name.endsWith(".xlsx")) {
            this.setState({
                errorArchivo: "El archivo debe ser formato .xlsx",
                datosPrevisualizacion: []
            });
            return;
        }

        var reader = new FileReader();
        var self = this;

        reader.onload = function (e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, { type: "array" });

            // Primera hoja del Excel
            var sheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[sheetName];

            // Convertimos a JSON
            var json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

            // Mapeo a tu estructura
            var datos = json.map(function (row) {
                return {
                    codigo: row["Código de barras"] || "",
                    nombre: row["Nombre"] || "",
                    marca: row["Marca"] || "",
                    descripcion: row["Descripción"] || "",
                    precio: row["Precio"] || "0.00",
                    cantidad: row["Existencias"] || "0",
                    existencias: row["Existencias"] || "0",
                    costo_compra: row["Costo compra"] || "0"
                };
            });

            self.setState({
                datosPrevisualizacion: datos,
                archivoFisico: file,
                paso: 2
            });
        };

        reader.readAsArrayBuffer(file);
    };


    // --- EVENTOS DE ARRASTRE ---
    onDragOver = (e) => {
        e.preventDefault();
        this.setState({ isDragging: true });
    };

    onDragLeave = () => {
        this.setState({ isDragging: false });
    };

    onDrop = (e) => {
        e.preventDefault();
        this.setState({ isDragging: false });
        var files = e.dataTransfer.files;
        if (files && files.length > 0) {
            this.procesarArchivoXLSX(files[0]);
        }
    };

    renderPaso1() {
        var dropzoneStyle = {
            border: this.state.isDragging ? '2px dashed #f1c40f' : '2px dashed #ccc',
            backgroundColor: this.state.isDragging ? '#fcf8e3' : '#f9f9f9',
            padding: '40px',
            borderRadius: '10px',
            cursor: 'pointer',
            textAlign: 'center',
            transition: 'all 0.3s'
        };

        return (
            <div className="text-left">
                <p>Sube tu archivo de excel (formato .xlsx) siguiendo nuestras indicaciones</p>
                
                <div style={{ marginBottom: '20px' }}>
                    <strong>1. Descarga la plantilla</strong>
                    <button className="btn btn-block" style={{ backgroundColor: '#ebebeb', marginTop: '10px' }} onClick={this.descargarPlantilla}>
                        <em className="fa fa-download"></em> Descargar Plantilla (.xlsx)
                    </button>
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <strong>2. Completa y guarda tu archivo</strong>
                    <p className="small text-muted">Asegúrate de guardar el archivo como "xlsx".</p>
                </div>

                <div>
                    <strong>3. Sube tu archivo</strong>
                    <div 
                        style={dropzoneStyle}
                        onClick={() => this.fileInputRef.current.click()}
                        onDragOver={this.onDragOver}
                        onDragLeave={this.onDragLeave}
                        onDrop={this.onDrop}
                    >
                        <em className="fa fa-cloud-upload" style={{ fontSize: '3em', color: '#999' }}></em>
                        <p style={{ marginTop: '10px' }}><strong>Arrastre o haga click para cargar documento</strong></p>
                        <p className="text-muted">Solo archivos .xlsx</p>
                        <input 
                            type="file" 
                            ref={this.fileInputRef} 
                            style={{ display: "none" }} 
                            accept=".xlsx"
                            onChange={(e) => this.procesarArchivoXLSX(e.target.files[0])}
                        />
                    </div>
                </div>
                {this.state.errorArchivo && (
                    <div className="alert alert-danger mt-3">
                        {this.state.errorArchivo}
                    </div>
                )}
            </div>
        );
    }

    renderPaso2() {
        return (
            <div>
                <p className="alert alert-info">Verifica la información antes de finalizar la carga masiva.</p>
                <BootstrapTable data={this.state.datosPrevisualizacion} striped hover pagination>
                    <TableHeaderColumn isKey dataField="codigo">Código</TableHeaderColumn>
                    <TableHeaderColumn dataField="nombre">Nombre</TableHeaderColumn>
                    <TableHeaderColumn dataField="marca">Marca</TableHeaderColumn>
                    <TableHeaderColumn dataField="precio">Precio Venta</TableHeaderColumn>
                    <TableHeaderColumn dataField="existencias">Stock</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }

    render() {
        var { show, onHide, alContinuar } = this.props;
        if (!show) return null;

        // Estilo para centrar el modal verticalmente y oscurecer el fondo
        var modalOverlayStyle = {
            display: 'flex',
            alignItems: 'center', // Centra verticalmente
            justifyContent: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1040
        };

        return (
            <div style={modalOverlayStyle}>
                {/* Quitamos las clases 'modal show' y usamos un div con estilo manual para control total */}
                <div className="modal-dialog" style={{ margin: 0, width: '100%', maxWidth: '600px' }}>
                    <div className="modal-content" style={{ borderRadius: '15px', padding: '10px' }}>
                        
                        {/* HEADER: Título izquierda, X derecha */}
                        <div className="modal-header" style={{ borderBottom: 'none', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <h4 className="modal-title" style={{ fontWeight: 'bold', margin: 0 }}>
                                Cargar catálogo de productos
                            </h4>
                            <button 
                                type="button" 
                                className="close" 
                                onClick={onHide} 
                                style={{ margin: 0, padding: '10px', fontSize: '24px' }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* BODY: Con minHeight para que no se vea apretado */}
                        <div className="modal-body" style={{ padding: '0px 40px 20px 40px', minHeight: '400px' }}>
                            {this.renderPaso1()}
                            
                            {/* Mensaje de éxito mejor ubicado */}
                            {this.state.datosPrevisualizacion && this.state.datosPrevisualizacion.length > 0 ? (
                                <div className="alert alert-success mt-4" style={{ borderRadius: '10px', border: 'none', backgroundColor: '#d4edda' }}>
                                    <em className="fa fa-check-circle" style={{ marginRight: '10px' }}></em> 
                                    <strong>¡Listo!</strong> Archivo cargado: {this.state.archivoFisico ? this.state.archivoFisico.name : ''}

                                </div>
                            ) : (
                                <div style={{ height: '60px' }}></div> // Espacio vacío para mantener el largo del modal
                            )}
                        </div>

                        {/* FOOTER */}
                        <div className="modal-footer" style={{ borderTop: 'none', padding: '20px 40px' }}>
                            <button 
                                className="btn btn-warning btn-block" 
                                style={{ 
                                    backgroundColor: '#f1c40f', 
                                    color: '#000', 
                                    fontWeight: 'bold', 
                                    borderRadius: '25px',
                                    padding: '12px',
                                    border: 'none',
                                    opacity: (this.state.datosPrevisualizacion && this.state.datosPrevisualizacion.length > 0) ? 1 : 0.5
                                }}
                                disabled={!this.state.datosPrevisualizacion || this.state.datosPrevisualizacion.length === 0}

                                onClick={() => alContinuar(this.state.datosPrevisualizacion, this.state.archivoFisico)}
                            >
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default ModalImportar;